// extracted by mini-css-extract-plugin
export default {"navigation":"src-components-Navigation-Navigation__navigation"};